<template>
    <div class="dc-tela">
        <!-- ============================================================
             CABEÇALHO: quem é o inscrito, o que é este webhook e o que fazer
             ============================================================ -->
        <div class="dc-cabecalho">
            <div class="dc-cabecalho__topo">
                <div class="dc-identidade">
                    <div class="dc-identidade__avatar">{{ iniciaisInscrito }}</div>
                    <div class="dc-identidade__texto">
                        <span class="dc-identidade__sobre">
                            Webhook #{{ requestWebhook.id }}
                            <template v-if="requestWebhook.created_at"> · recebido em {{ daraHoraBrasileiro(requestWebhook.created_at) }}</template>
                        </span>
                        <h2 class="dc-identidade__nome">{{ nomeInscrito }}</h2>
                        <div class="dc-identidade__selos">
                            <span class="badge badge-primary">{{ descricaoTipoWebhook(requestWebhook.tipoeventoaviso) }}</span>
                            <span v-if="requestWebhook.processado==1" class="badge badge-success"><b-icon icon="check-circle-fill"></b-icon> Processado</span>
                            <span v-else class="badge badge-warning"><b-icon icon="clock-history"></b-icon> Aguardando processamento</span>
                            <span v-if="insereAtualiza.insere_atualiza=='a'" class="badge badge-light">Aluno já enturmado no ERP</span>
                            <span v-else class="badge badge-light">Novo aluno no ERP</span>
                        </div>
                    </div>
                </div>

                <div class="dc-acoes">
                    <a class="btn btn-outline-primary" :href="urlCrm" target="_blank" rel="noopener">
                        <b-icon icon="box-arrow-up-right"></b-icon> Ver no CRM
                    </a>
                    <button type="button" class="btn btn-outline-primary" :disabled="requestWebhook.processado!=0" @click.prevent="getDadosInscricaoAluno()" title="Buscar novamente os dados do contato no CRM">
                        <b-icon icon="arrow-repeat"></b-icon> Atualizar dados do CRM
                    </button>
                    <button v-if="acaoRecomendada" type="button" class="btn btn-primary" @click.prevent="acaoRecomendada.executar()">
                        <b-icon icon="play-fill"></b-icon> {{ acaoRecomendada.rotulo }}
                    </button>
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ acaoRecomendada ? 'Mais ações' : 'Ações do usuário' }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <h6 class="dropdown-header">Integração ERP / CRM</h6>
                            <button v-for="acao in acoesErp" :key="acao.chave" type="button" class="dropdown-item" :class="{ disabled: !acao.habilitada }" :disabled="!acao.habilitada" @click.prevent="acao.habilitada && acao.executar()">
                                {{ acao.rotulo }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <dl class="dc-resumo">
                <div class="dc-resumo__item">
                    <dt>Oferta</dt>
                    <dd>{{ valor(codigoOferta) }}</dd>
                </div>
                <div class="dc-resumo__item dc-resumo__item--largo">
                    <dt>Turma ERP</dt>
                    <dd>{{ valor(ofertaAtual ? ofertaAtual.descricaocompleta : null) }}</dd>
                </div>
                <div class="dc-resumo__item">
                    <dt>Valor da inscrição</dt>
                    <dd>{{ valorInscricao }}</dd>
                </div>
                <div class="dc-resumo__item">
                    <dt>ID CRM</dt>
                    <dd>{{ valor(prospect && prospect.inscrito ? prospect.inscrito.id : null) }}</dd>
                </div>
                <div class="dc-resumo__item">
                    <dt>Reg. CRM</dt>
                    <dd>{{ valor(requestWebhook.registroprocesso) }}</dd>
                </div>
            </dl>

            <div class="dc-opcao-documentos">
                <b-form-checkbox
                    id="envia_inscricao_documentos"
                    name="envia_inscricao_documentos"
                    v-model="envia_inscricao_documentos"
                    :value="true"
                    :unchecked-value="false"
                    :disabled="insereAtualiza.insere_atualiza=='a'"
                    :switch="true"
                >
                    Enviar documentos entregues junto com a inscrição
                </b-form-checkbox>
                <small class="text-muted">Os documentos selecionados na aba <b>Documentação</b> são enviados ao ERP com a inscrição.</small>
            </div>

            <!-- Notas do processamento ainda não lidas -->
            <div v-if="notasNaoLidas>0" class="alert alert-warning dc-alerta-notas" role="status">
                <span><b-icon icon="bell-fill"></b-icon> Este webhook tem <b>{{ notasNaoLidas }} nota{{ notasNaoLidas>1 ? 's' : '' }} não lida{{ notasNaoLidas>1 ? 's' : '' }}</b> do processamento.</span>
                <button type="button" class="btn btn-sm btn-warning" @click="abrirAbaNotas()">Ver notas</button>
            </div>

            <!-- Situação / avisos do processamento -->
            <div class="dc-avisos" v-if="inscricaoAluno!=null">
                <template v-if="requestWebhook.processado==1">
                    <div v-if="requestWebhook.status=='success' && requestWebhook.json_inscricao!=null && requestWebhook.requisicao_id>0" class="alert alert-success" role="alert">
                        <b-icon icon="check-circle-fill"></b-icon> Inscrição já sincronizada com o GVCollege
                    </div>
                    <div v-else-if="requestWebhook.requisicao_id>0 && requestWebhook.json_inscricao!=null" class="alert alert-danger" role="alert">
                        <b-icon icon="exclamation-triangle-fill"></b-icon> {{ requestWebhook.status }}
                    </div>
                    <div v-if="requestWebhook.json_valor_matricula && requestWebhook.json_valor_matricula!=''" class="alert alert-success" role="alert">
                        <b-icon icon="check-circle-fill"></b-icon> Envio do valor da matrícula para o CRM já efetuado
                    </div>
                    <div v-if="requestWebhook.json_parcelamento_matricula && requestWebhook.json_parcelamento_matricula!=''" class="alert alert-success" role="alert">
                        <b-icon icon="check-circle-fill"></b-icon> {{ (requestWebhook.tipoeventoaviso=='c'?"Inscrição":(requestWebhook.tipoeventoaviso=='m'?"Matrícula":'Matrícula/Inscrição')) }} já sincronizada com o GVCollege
                    </div>
                    <div v-if="requestWebhook.status_post_contrato && requestWebhook.status_post_contrato=='success'" class="alert alert-success" role="alert">
                        <b-icon icon="check-circle-fill"></b-icon> Contrato já sincronizado com o ERP
                    </div>
                    <div v-if="requestWebhook.status_atualizacao_cadastral && requestWebhook.status_atualizacao_cadastral=='success'" class="alert alert-success" role="alert">
                        <b-icon icon="check-circle-fill"></b-icon> Atualização cadastral já sincronizada com o ERP
                    </div>
                    <div v-if="erro && erro.dadosInscricao && erro.dadosInscricao.message && possui_repasse==true" class="alert alert-danger" role="alert">
                        <b-icon icon="exclamation-triangle-fill"></b-icon> {{ erro.dadosInscricao.message }}
                    </div>
                </template>
                <template v-if="requestWebhook.processado==0">
                    <div v-if="erro && erro.erro == true && possui_repasse==true" class="alert alert-danger" role="alert" v-html="erro.message"></div>
                    <div v-if="CriticaInscricaoAluno && possui_repasse==true" :class="'alert alert-'+CriticaInscricaoAluno.tipo_critica" role="alert" v-html="CriticaInscricaoAluno.critica_mensagem"></div>
                    <div v-if="(requestWebhook.tipoeventoaviso=='m' || requestWebhook.tipoeventoaviso=='c') && possui_repasse==false" class="alert alert-danger" role="alert">
                        <b-icon icon="exclamation-triangle-fill"></b-icon> O repasse não foi realizado para a unidade.
                    </div>
                    <div v-if="requestWebhook.tipoeventoaviso=='a' && inscricaoAluno.Contrato && inscricaoAluno.Contrato.AssinouContrato && inscricaoAluno.Contrato.AssinouContrato!='Sim'" class="alert alert-danger" role="alert">
                        <b-icon icon="exclamation-triangle-fill"></b-icon> Não será possível processar este webhook pois o contrato não está assinado.
                    </div>
                    <div v-if="insereAtualiza.insere_atualiza=='i' && requestWebhook.tipoeventoaviso=='f'" class="alert alert-danger" role="alert">
                        <b-icon icon="exclamation-triangle-fill"></b-icon> Não será possível processar a Atualização Cadastral, pois não identificamos uma Inscrição/Matrícula realizada através de outro webhook.
                    </div>
                </template>
            </div>
        </div>

        <!-- ============================================================
             PESSOAS DA INSCRIÇÃO
             ============================================================ -->
        <div class="dc-bloco" v-if="inscricaoAluno!=null && possuiPessoa(inscricaoAluno.Pessoa)">
            <ul class="nav nav-tabs" id="dcPessoasTab" role="tablist">
                <li class="nav-item" v-for="(aba, i) in abasPessoas" :key="aba.id">
                    <a :class="'nav-link'+(i==0 ? ' active' : '')" :id="aba.id+'-tab'" data-toggle="tab" :href="'#'+aba.id" role="tab" :aria-controls="aba.id" :aria-selected="i==0 ? 'true' : 'false'">
                        <b-icon :icon="aba.icone"></b-icon> {{ aba.titulo }}
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div v-for="(aba, i) in abasPessoas" :key="aba.id" :class="'tab-pane fade'+(i==0 ? ' show active' : '')" :id="aba.id" role="tabpanel" :aria-labelledby="aba.id+'-tab'">
                    <pessoa-captacao :pessoa="aba.pessoa" :complemento="aba.complemento"></pessoa-captacao>
                </div>
            </div>
        </div>

        <!-- Carregando os dados do CRM -->
        <div class="dc-bloco dc-carregando" v-else>
            <div v-if="erro && erro.dadosInscricao && erro.dadosInscricao.message" class="alert alert-danger" role="alert">
                <b v-html="erro.dadosInscricao.message"></b>
            </div>
            <div v-else class="alert alert-info" role="alert">
                <b-icon icon="arrow-repeat" animation="spin"></b-icon> Aguarde, estamos requisitando as informações ao CRM...
            </div>
            <div class="dc-esqueleto">
                <span v-for="n in 8" :key="n" class="dc-esqueleto__linha"></span>
            </div>
        </div>

        <!-- ============================================================
             PROCESSO: documentos, financeiro, contrato e histórico
             ============================================================ -->
        <div class="dc-bloco">
            <ul class="nav nav-tabs" id="dcProcessoTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="documentos-tab" data-toggle="tab" href="#documentos" role="tab" aria-controls="documentos" aria-selected="true">
                        <b-icon icon="file-earmark-text"></b-icon> Documentação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="parcelas-tab" data-toggle="tab" href="#parcelas" role="tab" aria-controls="parcelas" aria-selected="false">
                        <b-icon icon="cash-stack"></b-icon> Parcelamento
                    </a>
                </li>
                <li v-if="inscricaoAluno && inscricaoAluno.Contrato" class="nav-item">
                    <a class="nav-link" id="contrato-tab" data-toggle="tab" href="#contrato" role="tab" aria-controls="contrato" aria-selected="false">
                        <b-icon icon="file-earmark-check"></b-icon> Contrato
                    </a>
                </li>
                <li v-if="requisicao_status!=null && requisicao_status.data" class="nav-item">
                    <a class="nav-link" id="statusrequisicao-tab" data-toggle="tab" href="#statusrequisicao" role="tab" aria-controls="statusrequisicao" aria-selected="false">
                        <b-icon icon="list-check"></b-icon> Status da requisição
                    </a>
                </li>
                <li v-if="prospect!=null && prospect.web_hooks && prospect.web_hooks.length>0" class="nav-item">
                    <a class="nav-link" id="webhooks-tab" data-toggle="tab" href="#webhooks" role="tab" aria-controls="webhooks" aria-selected="false">
                        <b-icon icon="clock-history"></b-icon> Histórico de webhooks
                        <span class="badge badge-light">{{ prospect.web_hooks.length }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="notas-tab" data-toggle="tab" href="#notas" role="tab" aria-controls="notas" aria-selected="false">
                        <b-icon icon="bell"></b-icon> Notas
                        <span v-if="notasNaoLidas>0" class="badge badge-warning" :title="notasNaoLidas+' não lida(s)'">{{ notasNaoLidas }}</span>
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <!-- Documentação -->
                <div class="tab-pane fade show active" id="documentos" role="tabpanel" aria-labelledby="documentos-tab">
                    <template v-if="inscricaoAluno && inscricaoAluno.Pessoa && inscricaoAluno.Pessoa.DocumentosEntregues && inscricaoAluno.Pessoa.DocumentosEntregues.length>0">
                        <p class="dc-dica" v-if="!envia_inscricao_documentos && insereAtualiza.insere_atualiza!='a'">
                            <b-icon icon="info-circle-fill"></b-icon> Para selecionar documentos, ative <b>Enviar documentos entregues junto com a inscrição</b> no topo da página.
                        </p>
                        <div class="ec-listagem">
                            <div class="table-responsive ec-listagem__rolagem">
                                <table class="table table-sm table-hover ec-tabela mb-0">
                                    <thead class="ec-thead">
                                        <tr>
                                            <th class="text-left">Documento ERP</th>
                                            <th class="text-left">Arquivo</th>
                                            <th class="text-left">Documento CRM</th>
                                            <th class="text-center">Enviado</th>
                                            <th class="text-center">Selecionar</th>
                                            <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="doc_entregue,key in inscricaoAluno.Pessoa.DocumentosEntregues" :key="key">
                                            <td class="text-left" data-label="Documento ERP">
                                                <span v-if="getDescricaoTipoDocumento(prospect ? prospect.tipos_documento : null, doc_entregue.TipoDocumento)!=false" class="ec-tabela__principal">
                                                    {{ getDescricaoTipoDocumento(prospect.tipos_documento, doc_entregue.TipoDocumento) }}
                                                </span>
                                                <span v-else class="ec-status ec-status--erro ec-status--rotulo">Não configurado</span>
                                            </td>
                                            <td class="text-left" data-label="Arquivo">{{ doc_entregue.nome }}</td>
                                            <td class="text-left" data-label="Documento CRM">
                                                <template v-if="doc_entregue.campo && doc_entregue.campo.nome">{{ doc_entregue.campo.nome }}</template>
                                                <span v-else class="ec-tabela__vazio">—</span>
                                            </td>
                                            <td class="text-center" data-label="Enviado">
                                                <span v-if="doc_entregue.documento_entregue" class="ec-status ec-status--sucesso">Enviado ao ERP</span>
                                                <span v-else class="ec-status ec-status--aviso">Não enviado</span>
                                            </td>
                                            <td class="text-center" data-label="Selecionar">
                                                <b-form-checkbox
                                                    :id="'upload_documento'+doc_entregue.TipoDocumento"
                                                    v-model="doc_entregue.selecionar"
                                                    :name="'upload_documento'+doc_entregue.TipoDocumento"
                                                    :value="true"
                                                    :unchecked-value="false"
                                                    :disabled="!envia_inscricao_documentos || doc_entregue.documento_entregue==true"
                                                    :switch="true"
                                                    :aria-label="'Selecionar documento '+doc_entregue.nome+' para envio com a inscrição'"
                                                ></b-form-checkbox>
                                            </td>
                                            <td class="ec-tabela__col-acoes">
                                                <div class="ec-acoes">
                                                    <a :href="urlDocs+'/doc/'+doc_entregue.id" class="btn btn-sm ec-acao" target="_blank" v-b-tooltip.hover title="Visualizar documento" aria-label="Visualizar documento"><b-icon icon="eye-fill"></b-icon></a>
                                                    <button v-if="insereAtualiza.insere_atualiza=='a' && doc_entregue.documento_vinculado==false" type="button" class="btn btn-sm ec-acao ec-acao--destaque" v-b-tooltip.hover title="Enviar documento ao ERP" aria-label="Enviar documento ao ERP" @click.prevent="uploadDocument(doc_entregue)"><b-icon icon="upload"></b-icon></button>
                                                    <span v-else class="d-inline-block" tabindex="0" v-b-tooltip.hover :title="motivoEnvioDocumentoIndisponivel(doc_entregue)">
                                                        <button type="button" class="btn btn-sm ec-acao dc-acao-indisponivel" disabled :aria-label="'Enviar documento ao ERP: '+motivoEnvioDocumentoIndisponivel(doc_entregue)"><b-icon icon="upload"></b-icon></button>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p class="dc-rodape-tabela">
                            <b-icon icon="exclamation-circle"></b-icon> Somente será possível enviar o documento para o ERP após a efetivação da matrícula do aluno no ERP na mesma oferta (turma) vinculada no CRM.
                        </p>
                    </template>
                    <div v-else-if="prospect!=null && prospect.documentos_entregues && prospect.documentos_entregues.length>0" class="ec-listagem">
                        <div class="table-responsive ec-listagem__rolagem">
                            <table class="table table-sm table-hover ec-tabela mb-0">
                                <thead class="ec-thead">
                                    <tr>
                                        <th class="text-left">Documento</th>
                                        <th class="text-left">Tipo de documento</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Upload</th>
                                        <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="doc_entregue,key in prospect.documentos_entregues" :key="key">
                                        <td class="text-left" data-label="Documento">
                                            <span class="ec-tabela__principal">{{ valor(doc_entregue.nome) }}</span>
                                            <small class="ec-tabela__secundario">ID {{ doc_entregue.id }}</small>
                                        </td>
                                        <td class="text-left" data-label="Tipo de documento">
                                            <select class="custom-select custom-select-sm dc-select-tipo" v-model="doc_entregue.codigodocumento" :aria-label="'Tipo de documento de '+doc_entregue.nome">
                                                <option :value="0">Selecione um documento</option>
                                                <option v-for="doc, key_doc in prospect.tipos_documento" :key="key_doc" :value="doc.codigodocumento">{{ doc.descricao }}</option>
                                            </select>
                                        </td>
                                        <td class="text-center" data-label="Status">
                                            <span v-if="doc_entregue.existe" class="ec-status ec-status--sucesso" v-b-tooltip.hover title="Documento vinculado a um tipo de documento do ERP">Vinculado ao ERP</span>
                                            <span v-else class="ec-status ec-status--aviso" v-b-tooltip.hover title="Escolha o tipo de documento do ERP para vincular">Sem vínculo</span>
                                        </td>
                                        <td class="text-center" data-label="Upload">
                                            <b-form-checkbox
                                                :id="'upload_documento'+doc_entregue.codigodocumento"
                                                v-model="doc_entregue.upload_documento"
                                                :name="'upload_documento'+doc_entregue.codigodocumento"
                                                :value="1"
                                                :unchecked-value="0"
                                                :switch="true"
                                            >
                                                {{ (doc_entregue.upload_documento==0?'Não':'Sim') }}
                                            </b-form-checkbox>
                                        </td>
                                        <td class="ec-tabela__col-acoes">
                                            <div class="ec-acoes">
                                                <a :href="doc_entregue.url" class="btn btn-sm ec-acao" target="_blank" v-b-tooltip.hover title="Visualizar documento" aria-label="Visualizar documento"><b-icon icon="eye-fill"></b-icon></a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else-if="inscricaoAluno==null" class="ec-listagem dc-vazio">
                        <b-icon icon="arrow-repeat" animation="spin" font-scale="2"></b-icon>
                        <p>Carregando documentos...</p>
                    </div>
                    <div v-else class="ec-listagem dc-vazio">
                        <b-icon icon="inbox" font-scale="2"></b-icon>
                        <p>Nenhum documento entregue.</p>
                    </div>
                </div>

                <!-- Parcelamento -->
                <div class="tab-pane fade" id="parcelas" role="tabpanel" aria-labelledby="parcelas-tab">
                    <div class="ec-listagem">
                        <div class="table-responsive ec-listagem__rolagem">
                            <table class="table table-sm table-hover ec-tabela dc-parcelas mb-0">
                                <thead class="ec-thead">
                                    <tr>
                                        <th class="text-center">Fatura</th>
                                        <th class="text-center">Vencimento</th>
                                        <th class="text-center">Competência</th>
                                        <th class="text-right">Débito</th>
                                        <th class="text-right">Pago</th>
                                        <th class="text-center">Pagamento</th>
                                        <th class="text-center">Crédito</th>
                                        <th class="text-center">Geração</th>
                                        <th class="text-center">Emissão</th>
                                    </tr>
                                </thead>
                                <tbody v-if="inscricaoAluno && inscricaoAluno.parcelamento && inscricaoAluno.parcelamento.length>0">
                                    <template v-for="parcela,item in inscricaoAluno.parcelamento">
                                        <tr :key="'parcela'+item">
                                            <td class="text-center" data-label="Fatura"><span class="ec-tabela__principal">{{ parcela.faturaId }}</span></td>
                                            <td class="text-center" data-label="Vencimento">{{ dataOuTraco(parcela.DataVencimento) }}</td>
                                            <td class="text-center" data-label="Competência">{{ valor(parcela.Competencia) }}</td>
                                            <td class="text-right" data-label="Débito">{{ formatarMoeda(parcela.ValorDebito) }}</td>
                                            <td class="text-right" data-label="Pago">{{ formatarMoeda(parcela.ValorPago) }}</td>
                                            <td class="text-center" data-label="Pagamento">{{ dataOuTraco(parcela.DataPagamento) }}</td>
                                            <td class="text-center" data-label="Crédito">
                                                <span v-if="parcela.DataCredito===false" class="ec-status ec-status--aviso">Sem repasse</span>
                                                <span v-else>{{ dataOuTraco(parcela.DataCredito) }}</span>
                                            </td>
                                            <td class="text-center" data-label="Geração">{{ dataOuTraco(parcela.DataGeracao) }}</td>
                                            <td class="text-center" data-label="Emissão">{{ dataOuTraco(parcela.DataEmissao) }}</td>
                                        </tr>
                                        <!-- eventos da parcela (mensalidade, desconto, serviço) logo abaixo dela -->
                                        <tr v-if="eventosParcela(parcela).length>0" :key="'eventos'+item" class="dc-subtabela">
                                            <td colspan="9">
                                                <span class="dc-subtabela__titulo">Eventos da fatura {{ parcela.faturaId }}</span>
                                                <table class="table table-sm mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">Descrição</th>
                                                            <th class="text-center">Evento</th>
                                                            <th class="text-right">Valor unitário</th>
                                                            <th class="text-right">Valor total</th>
                                                            <th class="text-center">Liquidado</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="evento, item_evento in eventosParcela(parcela)" :key="item_evento">
                                                            <td class="text-left" data-label="Descrição">{{ valor(evento.descricao) }}</td>
                                                            <td class="text-center" data-label="Evento">{{ evento.Evento }}</td>
                                                            <td class="text-right" data-label="Valor unitário">{{ formatarMoeda(evento.ValorUnitario) }}</td>
                                                            <td class="text-right" data-label="Valor total">{{ formatarMoeda(evento.ValorTotal) }}</td>
                                                            <td class="text-center" data-label="Liquidado">
                                                                <span v-if="evento.IndicaLiquidacao" class="ec-status ec-status--sucesso">Sim</span>
                                                                <span v-else class="ec-status ec-status--neutro">Não</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="9" class="ec-tabela__estado">
                                            <b-icon icon="inbox" font-scale="2"></b-icon>
                                            <p>Não identificamos parcelamentos.</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Contrato -->
                <div v-if="inscricaoAluno && inscricaoAluno.Contrato" class="tab-pane fade" id="contrato" role="tabpanel" aria-labelledby="contrato-tab">
                    <dl class="dc-resumo dc-resumo--contrato">
                        <div class="dc-resumo__item">
                            <dt>Número</dt>
                            <dd>{{ valor(inscricaoAluno.Contrato.Numero) }}</dd>
                        </div>
                        <div class="dc-resumo__item">
                            <dt>Data do aceite</dt>
                            <dd>{{ valor(inscricaoAluno.Contrato.DataAceite) }}</dd>
                        </div>
                        <div class="dc-resumo__item">
                            <dt>Assinado</dt>
                            <dd>
                                <span v-if="inscricaoAluno.Contrato.AssinouContrato=='Sim'" class="ec-status ec-status--sucesso">Sim</span>
                                <span v-else class="ec-status ec-status--erro">{{ valor(inscricaoAluno.Contrato.AssinouContrato) }}</span>
                            </dd>
                        </div>
                        <div class="dc-resumo__item dc-resumo__item--largo">
                            <dt>Arquivo</dt>
                            <dd class="dc-quebra"><a :href="inscricaoAluno.Contrato.ArquivoContrato" target="_blank" rel="noopener">{{ valor(inscricaoAluno.Contrato.ArquivoContrato) }}</a></dd>
                        </div>
                    </dl>
                    <a :href="(inscricaoAluno.Contrato.IdAnexo!=null ? urlDocs+'/doc/'+ inscricaoAluno.Contrato.IdAnexo : urlDocs+'/doc/'+convertBase64(inscricaoAluno.Contrato.ArquivoContrato))" class="btn btn-outline-primary btn-sm" target="_blank">
                        <b-icon icon="eye-fill"></b-icon> Visualizar contrato
                    </a>
                </div>

                <!-- Status da requisição -->
                <div v-if="requisicao_status!=null && requisicao_status.data" class="tab-pane fade" id="statusrequisicao" role="tabpanel" aria-labelledby="statusrequisicao-tab">
                    <dl class="dc-resumo dc-resumo--contrato">
                        <div class="dc-resumo__item">
                            <dt>Requisição</dt>
                            <dd>{{ requisicao_status.data.id }}</dd>
                        </div>
                        <div class="dc-resumo__item dc-resumo__item--largo">
                            <dt>Nome</dt>
                            <dd>{{ requisicao_status.data.pessoa ? requisicao_status.data.pessoa.nome : '—' }}</dd>
                        </div>
                        <div class="dc-resumo__item">
                            <dt>Data</dt>
                            <dd>{{ daraHoraBrasileiro(requisicao_status.data.created_at) }}</dd>
                        </div>
                        <div class="dc-resumo__item">
                            <dt>Etapa</dt>
                            <dd class="text-capitalize">{{ valor(requisicao_status.data.step) }}</dd>
                        </div>
                        <div class="dc-resumo__item">
                            <dt>Status</dt>
                            <dd><span :class="classeBadgeStatus(requisicao_status.data.status)">{{ getEstyloDescricaoStatusRequisicao(requisicao_status.data.status) }}</span></dd>
                        </div>
                    </dl>
                    <h6 class="dc-subtitulo">Processamento passo a passo (ERP)</h6>
                    <div class="ec-listagem">
                        <div class="table-responsive ec-listagem__rolagem">
                            <table class="table table-sm table-hover ec-tabela mb-0">
                                <thead class="ec-thead">
                                    <tr>
                                        <th class="text-left">Mensagem</th>
                                        <th class="text-center">Data</th>
                                        <th class="text-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="requisicao_status.data.logs && requisicao_status.data.logs.length>0">
                                        <tr v-for="log, item in requisicao_status.data.logs" :key="item">
                                            <td class="text-left dc-col-mensagem" data-label="Mensagem">
                                                <span class="ec-tabela__principal">{{ valor(log.mensagem) }}</span>
                                                <small class="ec-tabela__secundario">Passo #{{ log.id }}</small>
                                            </td>
                                            <td class="text-center" data-label="Data">{{ daraHoraBrasileiro(log.created_at) }}</td>
                                            <td class="text-center" data-label="Status"><span :class="classeBadgeStatus(log.status_id)">{{ getEstyloDescricaoStatusRequisicao(log.status_id) }}</span></td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="3" class="ec-tabela__estado">
                                            <b-icon icon="inbox" font-scale="2"></b-icon>
                                            <p>Nenhum passo de processamento registrado para esta requisição.</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Histórico de webhooks do contato -->
                <div v-if="prospect!=null && prospect.web_hooks && prospect.web_hooks.length>0" class="tab-pane fade" id="webhooks" role="tabpanel" aria-labelledby="webhooks-tab">
                    <div class="ec-listagem">
                        <div class="table-responsive ec-listagem__rolagem">
                            <table class="table table-sm table-hover ec-tabela mb-0">
                                <thead class="ec-thead">
                                    <tr>
                                        <th class="text-left">Webhook</th>
                                        <th class="text-center">Data</th>
                                        <th class="text-center">Sinc.</th>
                                        <th class="text-center">Status do evento</th>
                                        <th class="text-center">Status ERP</th>
                                        <th class="text-center">Origem</th>
                                        <th class="text-center">Requisição ERP</th>
                                        <th class="text-center">Contato CRM</th>
                                        <th class="text-left">Turma ERP</th>
                                        <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="aluno_captado,item in prospect.web_hooks" :key="item" :class="{ 'dc-linha-atual': webHook.id==aluno_captado.id }">
                                        <td class="text-left" data-label="Webhook">
                                            <span class="ec-tabela__principal">
                                                {{ descricaoTipoWebhook(aluno_captado.tipoeventoaviso) }}
                                                <span v-if="webHook.id==aluno_captado.id" class="ec-status ec-status--info ec-status--rotulo">Atual</span>
                                            </span>
                                            <small class="ec-tabela__secundario">#{{ aluno_captado.id }}</small>
                                        </td>
                                        <td class="text-center" data-label="Data">{{ daraHoraBrasileiro(aluno_captado.created_at) }}</td>
                                        <td class="text-center" data-label="Sinc.">
                                            <span v-if="aluno_captado.processado == 1" class="ec-status ec-status--sucesso">Processado</span>
                                            <span v-else class="ec-status ec-status--aviso">Não processado</span>
                                        </td>
                                        <td class="text-center" data-label="Status do evento">
                                            <span v-if="getDescricaoStatusRequisicao(aluno_captado)" :class="classeBadgeStatus(statusEventoWebhook(aluno_captado))">{{ getDescricaoStatusRequisicao(aluno_captado) }}</span>
                                            <span v-else class="ec-tabela__vazio">—</span>
                                        </td>
                                        <td class="text-center" data-label="Status ERP">
                                            <span :class="classeBadgeStatus(statusErpWebhook(aluno_captado))">{{ getEstyloDescricaoStatusRequisicao(statusErpWebhook(aluno_captado)) }}</span>
                                        </td>
                                        <td class="text-center" data-label="Origem">
                                            <template v-if="aluno_captado.origem_inclusao">{{ aluno_captado.origem_inclusao }}</template>
                                            <span v-else class="ec-tabela__vazio">—</span>
                                        </td>
                                        <td class="text-center" data-label="Requisição ERP">
                                            <template v-if="aluno_captado.requisicao_id">{{ aluno_captado.requisicao_id }}</template>
                                            <span v-else class="ec-tabela__vazio">—</span>
                                        </td>
                                        <td class="text-center" data-label="Contato CRM">
                                            <template v-if="contatoIdCrm(aluno_captado)">{{ contatoIdCrm(aluno_captado) }}</template>
                                            <span v-else class="ec-tabela__vazio">—</span>
                                        </td>
                                        <td class="text-left" data-label="Turma ERP">
                                            <template v-if="aluno_captado.descricaocompleta">{{ aluno_captado.descricaocompleta }}</template>
                                            <span v-else class="ec-tabela__vazio">—</span>
                                        </td>
                                        <td class="ec-tabela__col-acoes">
                                            <div class="ec-acoes">
                                                <a v-if="webHook.id!=aluno_captado.id" :href="'/Access/Unity/Unitie/'+prospect.oferta.unity_id+'/captacao/wh/'+aluno_captado.id" class="btn btn-sm ec-acao ec-acao--destaque" v-b-tooltip.hover title="Abrir este webhook" :aria-label="'Abrir o webhook #'+aluno_captado.id"><b-icon icon="eye-fill"></b-icon></a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Notas do processamento -->
                <div class="tab-pane fade" id="notas" role="tabpanel" aria-labelledby="notas-tab">
                    <notas-webhook ref="notasWebhook" :unidade-id="unidade.id" :webhook-id="webHook.id" :notas-iniciais="notas || []" @nao-lidas="notasNaoLidas = $event"></notas-webhook>
                </div>
            </div>
        </div>

        <loading id="sincronizarEnvioInscricao" titulo="Enviando Inscrição para o ERP, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <loading id="GetDadosInscrito" titulo="Obtendo dados dos contatos no CRM, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <loading id="EnviarValorMatricula" titulo="Enviando Valor da Matrícula para o CRM, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <loading id="EnviarAtualizacaoMatricula" titulo="Enviando Atualização Cadastral para o ERP, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <loading id="UploadFile" titulo="Postando arquivo no ERP, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <modal-component titulo="VISUALIZADOR" label-btn-fechar="Fechar" id="visualizadorNotas" url-redirect="" :sem-padding="true">
            <template v-slot:conteudo>
                <div class="card">
                    <div class="card-header">
                        <b style="font-size: 12px;">UPLOAD DOCUMENTO</b>
                    </div>
                    <div class="card-body" v-html="resposta.message" style="font-size: 14px;text-align: left;">

                    </div>
                </div>
            </template>
        </modal-component>
    </div>

</template>

<script>
import PessoaCaptacao from './PessoaCaptacao.vue'
import NotasWebhook from '../Notificacao/NotasWebhook.vue'

export default {
    components:{ PessoaCaptacao, NotasWebhook },
    props:[
        // 'dadosCaptacao',
        'webHook',
        'unidade',
        'permissaoUsuario',
        'oferta',
        'objetoInscricao',
        'insereAtualiza',
        'objetoParcelamento',
        'objetoAtualizacaoCadastral',
        'notas'
        // 'listaEstadoCivil',
        // 'listaEtinia',
        // 'configuracaoFinanceira',
        // 'statusRequisicao'
    ],
    watch:{
        // 'inscricaoAluno.Pessoa.DocumentosEntregues':{
        //     handler:function(newvalue,oldvalue){
        //         let index = this.inscricaoAluno.Pessoa.DocumentosEntregues.findIndex(documento => documento.id === fileUpload.id);
        //         this.inscricaoAluno.Pessoa.DocumentosEntregues[index].upload_documento = response.data.documento.upload_documento
        //              // for(let i=0 ; i<this.inscricaoAluno.Pessoa.DocumentosEntregues.length;i++){
        //             //     this.inscricaoAluno.Pessoa.DocumentosEntregues[i].upload_documento = ( newvalue.documento_vinculado == true ? 1 : 0 )
                        
        //             //     console.log('velho: '+ oldvalue+' - novo: '+ newvalue+' - objeto: '+this.inscricaoAluno.Pessoa.DocumentosEntregues[i].upload_documento ,this.inscricaoAluno.Pessoa.DocumentosEntregues[i])           
        //             // }
                    
        //             console.log({...newvalue})
        //     },
        //     deep:true
        // },
        envia_inscricao_documentos(newvalue,oldvalue){
            if(this.webHook.processado == 0){
                if(this.inscricaoAluno.Pessoa && this.inscricaoAluno.Pessoa.DocumentosEntregues && this.inscricaoAluno.Pessoa.DocumentosEntregues.length>0){

                    for(let i=0 ; i<this.inscricaoAluno.Pessoa.DocumentosEntregues.length;i++){
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[i].upload_documento = ( newvalue == true && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==false ? 1 : 0 )
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_vinculado = ( newvalue == true && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==false ? true : ( newvalue == false && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==false ? false : ( newvalue == false && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==true ? true : false ) ) )
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[i].selecionar = ( newvalue == true && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==false ? true : ( newvalue == false && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==false ? false : ( newvalue == false && this.inscricaoAluno.Pessoa.DocumentosEntregues[i].documento_entregue==true ? true : false ) ) )
                        console.log('velho: '+ oldvalue+' - novo: '+newvalue ,this.inscricaoAluno.Pessoa.DocumentosEntregues[i])           
                    }
                }
            }
        }
        
    },
    data(){
        return{
            resposta:{
                message:null,
            },
            possui_repasse:true,
            urlDocs:window.location.href,
            prospect:null,
            requestWebhook:null,
            notasNaoLidas:0,
            requisicao_status:null,
            pagamento_taxa_inscricao:null,
            pagamento_taxa_matricula:null,
            inscricaoAluno:null,
            CriticaInscricaoAluno:null,
            ParcelamentoMatricula:null,
            AtualizacaoCadastralMatricula:null,
            listaEstadoCivil:null,
            listaEtinia:null,
            configuracaoFinanceira:null,
            statusRequisicao:null,
            erro:null,
            envia_inscricao_documentos:false,
        }
    },
    computed:{
        nomeInscrito(){
            if(this.inscricaoAluno && this.inscricaoAluno.Pessoa && this.inscricaoAluno.Pessoa.DadosGerais && this.inscricaoAluno.Pessoa.DadosGerais.Nome){
                return this.inscricaoAluno.Pessoa.DadosGerais.Nome
            }
            return (this.requestWebhook && this.requestWebhook.nomeinscrito ? this.requestWebhook.nomeinscrito : 'Inscrito')
        },
        iniciaisInscrito(){
            let partes = this.nomeInscrito.trim().split(/\s+/)
            return ((partes[0] || '').charAt(0) + (partes.length>1 ? partes[partes.length-1].charAt(0) : '')).toUpperCase()
        },
        urlCrm(){
            return 'https://crmsantamarcelina.apprubeus.com.br/contato/'+this.requestWebhook.contatoid+'/registro/'+this.requestWebhook.registroprocesso
        },
        // oferta vinda do CRM (após carregar) ou, enquanto isso, a oferta enviada pelo controller
        ofertaAtual(){
            return (this.prospect && this.prospect.oferta ? this.prospect.oferta : this.oferta)
        },
        codigoOferta(){
            if(!this.ofertaAtual){
                return null
            }
            return (this.ofertaAtual.codigooferta!=null ? this.ofertaAtual.codigooferta : this.ofertaAtual.codigoofertapse)
        },
        valorInscricao(){
            // prospect.oferta.valoroferta já chega formatado por formatPrice() em getDadosInscricaoAluno()
            if(this.prospect && this.prospect.oferta){
                return (this.prospect.oferta.valoroferta ? 'R$ '+this.prospect.oferta.valoroferta : '—')
            }
            return (this.oferta ? this.formatarMoeda(this.oferta.valoroferta) : '—')
        },
        abasPessoas(){
            if(!this.inscricaoAluno){
                return []
            }
            let prospect = this.prospect || {}
            return [
                { id:'aluno',   titulo:'Aluno',             icone:'person-fill',   pessoa:this.inscricaoAluno.Pessoa,          complemento:prospect.inscrito || null },
                { id:'pai',     titulo:'Pai',               icone:'person',        pessoa:this.inscricaoAluno.Pai,             complemento:prospect.pai || null },
                { id:'mae',     titulo:'Mãe',               icone:'person',        pessoa:this.inscricaoAluno.Mae,             complemento:prospect.mae || null },
                { id:'respedu', titulo:'Resp. Educacional', icone:'book'  ,   pessoa:this.inscricaoAluno.RespEducacional, complemento:prospect.responsavel || null },
                { id:'respfin', titulo:'Resp. Financeiro',  icone:'wallet2',       pessoa:this.inscricaoAluno.RespFinanceiro,  complemento:prospect.responsavelfinanceiro || null },
            ].filter(aba => this.possuiPessoa(aba.pessoa))
        },
        // Ações de integração, na mesma ordem e com as mesmas regras do antigo menu "Ações do Usuário"
        acoesErp(){
            let wh = this.requestWebhook
            let ia = this.insereAtualiza.insere_atualiza
            let semTrava = (this.CriticaInscricaoAluno && this.CriticaInscricaoAluno.trava_inscricao == false)
            let repasse = (this.possui_repasse==true)
            let pendente = (wh.processado==0)

            let inscricao = { chave:'inscricao', rotulo:'Enviar Inscrição ERP', habilitada:false, executar:() => this.enviarInscricaoProcessamento() }
            if(ia=='i' && wh.tipoeventoaviso!='v' && wh.tipoeventoaviso!='f' && repasse && pendente && semTrava){
                inscricao.habilitada = true
            }else if(ia=='i' && wh.tipoeventoaviso=='a' && pendente){
                inscricao.habilitada = true
            }else if(ia=='a' && wh.tipoeventoaviso=='c' && pendente && repasse && semTrava){
                inscricao = { chave:'inscricao', rotulo:'Confirmar Inscrição ERP', habilitada:true, executar:() => this.confirmarMatriculaErp() }
            }

            let cf = this.configuracaoFinanceira
            return [
                inscricao,
                {
                    chave:'matricula', rotulo:'Confirmar Matrícula ERP',
                    habilitada:(ia=='a' && wh.tipoeventoaviso=='m' && pendente && repasse && semTrava),
                    executar:() => this.confirmarMatriculaErp(),
                },
                {
                    chave:'contrato', rotulo:'Enviar Contrato ERP',
                    habilitada:(ia=='a' && wh.tipoeventoaviso=='a' && pendente),
                    executar:() => this.enviarContratoErp(),
                },
                {
                    chave:'valormatricula', rotulo:'Enviar Valor Matrícula CRM',
                    habilitada:(wh.tipoeventoaviso=='v' && wh.valormatricula==null && cf!=null && ((cf.etapaenvioeventoaviso=='contratoaceito' && wh.tipoeventoaviso=='a') || (cf.etapaenvioeventoaviso=='inscricaoconfirmada' && wh.tipoeventoaviso=='c') || (wh.tipoeventoaviso=='v'))),
                    executar:() => this.dispararEventoValorMatricula(),
                },
                {
                    chave:'atualizacao', rotulo:'Atualizar Cadastro ERP',
                    habilitada:(ia=='a' && wh.tipoeventoaviso=='f' && pendente),
                    executar:() => this.atualizarCadastroERP(),
                },
                {
                    chave:'numeromatricula', rotulo:'Enviar Nº de Matrícula CRM', naoRecomendar:true,
                    habilitada:(wh.processado==1 && wh.json_inscricao!='' && wh.status=='success' && wh.status_inscricao=='success' && wh.matriculaerp==null),
                    executar:() => this.enviarNumeroMatriculaCrm(),
                },
            ]
        },
        // primeira ação disponível: vira o botão principal do cabeçalho
        acaoRecomendada(){
            if(this.inscricaoAluno==null){
                return null
            }
            return this.acoesErp.find(acao => acao.habilitada && !acao.naoRecomendar) || null
        },
    },
    methods:{
        abrirAbaNotas(){
            $('#notas-tab').tab('show')
            document.getElementById('notas-tab').scrollIntoView({ behavior: 'smooth', block: 'start' })
        },
        valor(texto){
            return (texto===null || texto===undefined || (''+texto).trim()=='' ? '—' : texto)
        },
        possuiPessoa(pessoa){
            return !!(pessoa && pessoa!=0)
        },
        dataOuTraco(data){
            return (data ? this.valor(this.formatDate(data,2)) : '—')
        },
        formatarMoeda(valor){
            let numero = parseFloat(valor)
            if(valor===null || valor===undefined || valor==='' || isNaN(numero)){
                return '—'
            }
            return numero.toLocaleString('pt-BR', { style:'currency', currency:'BRL' })
        },
        descricaoTipoWebhook(tipo){
            let tipos = {
                c:'Inscrição Confirmada',
                a:'Contrato Assinado',
                m:'Matriculado',
                v:'Envia Valor CRM',
                f:'Atualização Cadastral',
                d:'Documentos',
                EnviaMatriculaCrm:'Enviar Matrícula CRM',
            }
            return tipos[tipo] || 'Outros'
        },
        // classe do selo de status (padrão .ec-status das tabelas)
        classeBadgeStatus(status){
            if(status==null || status===''){
                return 'ec-status ec-status--neutro'
            }else if(status=='success' || status==2){
                return 'ec-status ec-status--sucesso'
            }else if(status=='error' || status==3){
                return 'ec-status ec-status--erro'
            }else if(status=='pending' || status==1){
                return 'ec-status ec-status--info'
            }else if(status=='warning' || status==4){
                return 'ec-status ec-status--aviso'
            }
            return 'ec-status ec-status--neutro'
        },
        // motivo exibido no tooltip quando o envio do documento ao ERP está indisponível
        motivoEnvioDocumentoIndisponivel(doc_entregue){
            if(this.insereAtualiza.insere_atualiza!='a'){
                return 'Disponível somente após a matrícula do aluno no ERP'
            }
            return 'Documento já vinculado ao ERP'
        },
        // status do evento conforme o tipo do webhook (mesma regra de getDescricaoStatusRequisicao)
        statusEventoWebhook(aluno_captado){
            if(aluno_captado.tipoeventoaviso=='c' && aluno_captado.status_inscricao!=null){
                return aluno_captado.status_inscricao
            }else if(aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_post_contrato!=null){
                return aluno_captado.status_post_contrato
            }else if(aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_inscricao!=null){
                return aluno_captado.status_inscricao
            }else if(aluno_captado.tipoeventoaviso=='m' && aluno_captado.status_inscricao!=null){
                return aluno_captado.status_inscricao
            }else if(aluno_captado.tipoeventoaviso=='v' && aluno_captado.status_valormatricula!=null){
                return aluno_captado.status_valormatricula
            }
            return aluno_captado.status
        },
        // primeiro status de integração preenchido do webhook
        statusErpWebhook(aluno_captado){
            if(aluno_captado.status_inscricao!=null) return aluno_captado.status_inscricao
            if(aluno_captado.status_valormatricula!=null) return aluno_captado.status_valormatricula
            if(aluno_captado.status_post_contrato!=null) return aluno_captado.status_post_contrato
            if(aluno_captado.status_atualizacao_cadastral!=null) return aluno_captado.status_atualizacao_cadastral
            return aluno_captado.status
        },
        contatoIdCrm(aluno_captado){
            try{
                let corpo = JSON.parse(aluno_captado.request_body)
                return (corpo && corpo.contato ? corpo.contato.id : '')
            }catch(e){
                return ''
            }
        },
        // eventos da parcela configurados na oferta (mensalidade, desconto e serviço), com a descrição
        eventosParcela(parcela){
            if(!this.prospect || !parcela.Evento || parcela.Evento.length==0){
                return []
            }
            let tipos = [
                { codigo:this.prospect.codigoevento,         descricao:this.prospect.descricaoevento },
                { codigo:this.prospect.codigoeventodesconto, descricao:this.prospect.descricaoeventodesconto },
                { codigo:this.prospect.codigoeventoservico,  descricao:this.prospect.descricaoeventoservico },
            ]
            let eventos = []
            tipos.forEach(tipo => {
                if(!tipo.codigo){
                    return
                }
                parcela.Evento.filter(evento => evento.Evento==tipo.codigo).forEach(evento => {
                    eventos.push(Object.assign({}, evento, { descricao:tipo.descricao }))
                })
            })
            return eventos
        },
        uploadDocument(fileUpload){
            let urlUpload = '/api/v1/Erp/Inscricoes/'+this.unidade.id+'/wh/'+this.requestWebhook.id+'/upload/'+fileUpload.id
            this.erro = null;
            
            $('#UploadFile').modal('show');
            
            
            
            var config = {
                method: 'get',
                url: urlUpload,
                // headers: {
                //         'Accept': 'application/json',
                //         'Authorization': this.$root.token(),
                //     },
                };
            
            axios(config)
                .then(response => {
                    
                    if(response.data.erro==false){
                        let index = this.inscricaoAluno.Pessoa.DocumentosEntregues.findIndex(documento => documento.id === fileUpload.id);
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[index].documento_vinculado = response.data.documento.documento_vinculado
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[index].IdAnexo = response.data.documento.IdAnexo
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[index].vinculo_aluno_documento = response.data.documento.vinculo_aluno_documento
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[index].upload_documento = response.data.documento.upload_documento
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[index].documento_postado = response.data.documento.documento_postado
                        this.inscricaoAluno.Pessoa.DocumentosEntregues[index].documento_entregue = (response.data.documento.vinculo_aluno_documento==1 ? true : false)
                        
                        this.resposta = {message:response.data.message}
                        console.log("Atualizado",this.inscricaoAluno.Pessoa.DocumentosEntregues[index])
                        // for(let a = 0; a < this.inscricaoAluno.Pessoa.DocumentosEntregues.length;a++){
                        //     if(this.inscricaoAluno.Pessoa.DocumentosEntregues[a].id==response.data.documento.id){
                        //         console.log(this.inscricaoAluno.Pessoa.DocumentosEntregues[a].id,response.data.documento.id)
                        //         this.inscricaoAluno.Pessoa.DocumentosEntregues[a]={...response.data.documento}
                        //         // this.inscricaoAluno.Pessoa.DocumentosEntregues[a].upload_documento=response.data.documento.upload_documento
                        //         // this.inscricaoAluno.Pessoa.DocumentosEntregues[a].documento_vinculado=response.data.documento.documento_vinculado
                        //     }
                        // }
                    }else if(response.data.erro==true){
                        this.resposta = {message:response.data.message}
                    }
                    console.log(response.data);
                    
                    $('#UploadFile').modal('hide');
                    $('#visualizadorNotas').modal('show');
                    
                })
                .catch(errors => {
                    $('#UploadFile').modal('hide');
                    $('#visualizadorNotas').modal('show');
                    console.log(errors.response)
                    this.erro =(errors.response.data.dadosInscricao && errors.response.data.dadosInscricao.message ? response.data:null) 
                    this.resposta = {message:errors.response.data.message}
                    window.alert("Houve um erro ao realizar o upload do arquivo para o ERP")
                    
                })
        
                console.log(fileUpload,urlUpload);
        },
        possuiRepasse(){

            if((this.requestWebhook.tipoeventoaviso=='m' || this.requestWebhook.tipoeventoaviso=='c')){
                if(this.inscricaoAluno.parcelamento && this.inscricaoAluno.parcelamento.length>0){
                    console.log('data crédito 1',this.inscricaoAluno.parcelamento[0].DataCredito)
                    if(this.inscricaoAluno.parcelamento[0].DataCredito==false){
                        this.possui_repasse = false;
                    }else{
                        this.possui_repasse = true;
                    }
                }
            }
        },
        convertBase64(text){
            return window.btoa(encodeURI(text))
        },
        isMail(email){
            let myArray = email.split("");

            let result = myArray.filter( (letra) => (letra == "@" ? true : false) );

            if(result.length>0 && result[0]=="@"){
                
                return true
            }else{
                
                return false
            }

        },
        retornaString( valor ){
            return ""+valor
        },
        formatPrice(value) {
            
            let aaa = ""+parseFloat(value).toFixed(2)
            console.log('aaa',aaa)
            //let val = Number(aaa.replace(".", ","));
            //if (!val) return '0,00';
            let valueString = aaa.replace(".", ",");
            return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        getDescricaoTipoDocumento(listaDocumentos, tipodocumento){
            if(!listaDocumentos){
                return false;
            }

            for(let i = 0; i < listaDocumentos.length;i++){
                
                if(listaDocumentos[i].codigodocumento==tipodocumento){

                    // console.log(listaDocumentos[i].descricao,tipodocumento)
                    return listaDocumentos[i].descricao
                }

            }

            return false;
        },
        getDadosInscricaoAluno(){
            this.erro = null;
            $('#GetDadosInscrito').modal('show');
            let url = '/api/v1/Crm/getDadosInscricaoAluno/'+this.unidade.id+'/captacao/wh/'+this.webHook.id

            console.log('URL: ' + url)
            var config = {
                method: 'get',
                url: url,
                // headers: {
                //         'Accept': 'application/json',
                //         'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    console.log('response.data',response.data)
                    if(this.listaEstadoCivil = response.data.dadosInscricao && this.listaEstadoCivil == response.data.dadosInscricao.erro==false){
                        
                        if(response.data.dadosInscricao.InformacoesWebHook){

                            this.inscricaoAluno = response.data.dadosInscricao.InformacoesWebHook
                            this.CriticaInscricaoAluno = response.data.critica
                            console.log("this.critica.",response.data.critica)
                            this.ParcelamentoMatricula.Parcelamento = (this.inscricaoAluno && this.inscricaoAluno.parcelamento ? this.inscricaoAluno.parcelamento : 0)
                            if(this.AtualizacaoCadastralMatricula && this.AtualizacaoCadastralMatricula.Pessoa){

                                this.AtualizacaoCadastralMatricula.Pessoa = this.inscricaoAluno.Pessoa
                            }

                            if(this.AtualizacaoCadastralMatricula && this.AtualizacaoCadastralMatricula.Pai){
                                this.AtualizacaoCadastralMatricula.Pai = this.inscricaoAluno.Pai
                            }

                            if(this.AtualizacaoCadastralMatricula && this.AtualizacaoCadastralMatricula.Mae){
                                this.AtualizacaoCadastralMatricula.Mae = this.inscricaoAluno.Mae
                            }
                            console.log("this.inscricaoAluno",this.inscricaoAluno)
                            this.possuiRepasse()

                        }

                        if(response.data.dadosInscricao.lista_ec){

                            this.listaEstadoCivil = response.data.dadosInscricao.lista_ec;

                        }

                        if(response.data.dadosInscricao.lista_etnias){

                            this.listaEtinia = response.data.dadosInscricao.lista_etnias;

                        }
                        if(response.data.dadosInscricao.configuracao_financeira_inscricao){
                            
                            this.configuracaoFinanceira =response.data.dadosInscricao.configuracao_financeira_inscricao;

                        }

                        if(response.data.dadosInscricao.request_status_inscricao){

                            this.requisicao_status = response.data.dadosInscricao.request_status_inscricao;

                        }

                        if(response.data.dadosInscricao.dadosContato){
                            
                            this.prospect = response.data.dadosInscricao.dadosContato;
                            this.prospect.oferta.valoroferta = this.formatPrice(this.prospect.oferta.valoroferta)

                        }

                        
    
                        if(this.prospect){

                            if(this.prospect.inscrito.datanascimento){
        
                                this.prospect.inscrito.datanascimento = this.formatDate(this.prospect.inscrito.datanascimento + " 00:00:00",2)
        
                            }else{
                                this.prospect.inscrito.datanascimento = null
                            }

                            if(this.prospect.inscrito.data_expedicao_rg){
        
                                this.prospect.inscrito.data_expedicao_rg = this.formatDate(this.prospect.inscrito.data_expedicao_rg + " 00:00:00",2)
        
                            }else{
                                this.prospect.inscrito.data_expedicao_rg = null
                            }

                        }
    
                        if(this.prospect){

                            if(this.prospect.pai && this.prospect.pai.datanascimento){
        
                                this.prospect.pai.datanascimento = this.formatDate(this.prospect.pai.datanascimento + " 00:00:00",2)
        
                            }
        
                            if(this.prospect.pai && this.prospect.pai.data_expedicao_rg){
        
                                this.prospect.pai.data_expedicao_rg = this.formatDate(this.prospect.pai.data_expedicao_rg + " 00:00:00",2)
        
                            }

                        }
    
                        if(this.prospect){

                            if(this.prospect.mae && this.prospect.mae.datanascimento){
        
                                this.prospect.mae.datanascimento = this.formatDate(this.prospect.mae.datanascimento + " 00:00:00",2)
        
                            }
        
                            if(this.prospect.mae && this.prospect.mae.data_expedicao_rg){
        
                                this.prospect.mae.data_expedicao_rg = this.formatDate(this.prospect.mae.data_expedicao_rg + " 00:00:00",2)
        
                            }

                        }
                        
                        if(this.prospect){

                            if(this.prospect.responsavelfinanceiro && this.prospect.responsavelfinanceiro.datanascimento){
        
                                this.prospect.responsavelfinanceiro.datanascimento = this.formatDate(this.prospect.responsavelfinanceiro.datanascimento + " 00:00:00",2)
        
                            }

                            if(this.prospect.responsavelfinanceiro && this.prospect.responsavelfinanceiro.data_expedicao_rg){
        
                                this.prospect.responsavelfinanceiro.data_expedicao_rg = this.formatDate(this.prospect.responsavelfinanceiro.data_expedicao_rg + " 00:00:00",2)
        
                            }
                        }

                        if(!this.prospect){
                            this.erro = response.data
                            
                            if(this.erro.dadosInscricao.erro==true){

                                //window.alert(this.erro.dadosInscricao.message)
                                console.log('mensagem',this.erro);

                            }
                        }
                        console.log('this.prospect',this.prospect)
                        // this.documentosEntreguesAluno()
                    }else{
                        window.alert('houve um erro')
                        this.mensagem = response.data
                        console.log('mensagem',this.mensagem);
                        
                    }
                    $('#GetDadosInscrito').modal('hide');
                })
                .catch(function (error) {
                    console.log('error',error);
                    window.alert('houve um erro no processamento da inscrição')
                    $('#GetDadosInscrito').modal('hide');
                    //this.erro = error
                    console.log(error);
                });
                
                
        },
        enviarInscricaoProcessamento(){
            this.erro = null;
            if(this.possui_repasse==true){
                $('#sincronizarEnvioInscricao').modal('show');
                let url='/api/v1/Erp/Inscricoes/'+this.unidade.id+'/inscreveraluno';
                
                let formData = new FormData();
                console.log('this.prospect.objeto_inscricao 2',this.inscricaoAluno)
                formData.append('inscricao', JSON.stringify(this.inscricaoAluno))
                formData.append('webhook', JSON.stringify(this.webHook))
                formData.append('envia_inscricao_documetos',this.envia_inscricao_documentos)
                
                
                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }
                
                axios.post(url,formData,configuracao)
                    .then(response => {
                        
                        if(response.data.web_hook){
                            
                            this.requestWebhook = response.data.web_hook;

                        }
                        if(response.data.request_status_inscricao){

                            this.requisicao_status = response.data.request_status_inscricao;

                        }

                        if(response.data.erro && response.data.erro == true){
                            this.erro = response.data;
                        }
                        console.log(response.data)
                        $('#sincronizarEnvioInscricao').modal('hide');
                    })
                    .catch(errors => {
                        console.log(errors.response.data)
                        this.erro = errors.response.data
                        $('#sincronizarEnvioInscricao').modal('hide');
                        window.alert("Houve um erro ao enviar a inscrição para o ERP")
                        
                    })
            }else{
                window.alert('Não será possível enviar a Parcela, pois o repasse ainda não foi realizado.')
            }
        
        },
        atualizarCadastroERP(){
                        
            this.erro = null;
            $('#EnviarAtualizacaoMatricula').modal('show');
            let url='/api/v1/Erp/Inscricoes/'+this.unidade.id+'/atualizacao_cadastral_matricula';
            
            let formData = new FormData();
            console.log('atualizacao_cadastral',this.AtualizacaoCadastralMatricula)
            formData.append('atualizacao_cadastral', JSON.stringify(this.AtualizacaoCadastralMatricula))
            formData.append('webhook', JSON.stringify(this.webHook))
            formData.append('envia_inscricao_documetos',this.envia_inscricao_documentos)
            
            
            let configuracao = {
                // method:'post',
                // headers:{
                //     // // 'Accept': 'application/json',
                //     // // 'Authorization': this.$root.token(),
                // }
            }
            
            axios.post(url,formData,configuracao)
                .then(response => {
                    
                    if(response.data.web_hook){
                        
                        this.requestWebhook = response.data.web_hook;

                    }
                    if(response.data.obj_atualizacao_cadastral){

                        this.AtualizacaoCadastralMatricula = response.data.obj_atualizacao_cadastral;

                    }

                    if(response.data.erro && response.data.erro == true){
                        this.erro = response.data;
                    }
                    console.log(response.data)
                    $('#EnviarAtualizacaoMatricula').modal('hide');
                })
                .catch(errors => {
                    console.log(errors.response)
                    $('#EnviarAtualizacaoMatricula').modal('hide');
                    window.alert("Houve um erro ao enviar a Atualização Cadastral para o ERP")
                    
                })
        
        
        
        },
        confirmarMatriculaErp(){
            this.erro = null;
            if(this.possui_repasse==true){

                $('#sincronizarEnvioInscricao').modal('show');
                let url='/api/v1/Erp/Inscricoes/'+this.unidade.id+'/incluirparcelamatricula';
                
                let formData = new FormData();
                console.log('parcelamento',this.ParcelamentoMatricula)
                formData.append('parcelamento', JSON.stringify(this.ParcelamentoMatricula))
                formData.append('webhook', JSON.stringify(this.webHook))
                
                
                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }
                
                axios.post(url,formData,configuracao)
                    .then(response => {
                        
                        if(response.data.web_hook){
                            
                            this.requestWebhook = response.data.web_hook;
    
                        }
                        if(response.data.request_status_inscricao){
    
                            this.requisicao_status = response.data.request_status_inscricao;
    
                        }
    
                        if(response.data.erro && response.data.erro == true){
                            this.erro = response.data;
                        }
                        console.log(response.data)
                        $('#sincronizarEnvioInscricao').modal('hide');
                    })
                    .catch(errors => {
                        console.log(errors.response)
                        $('#sincronizarEnvioInscricao').modal('hide');
                        window.alert("Houve um erro ao enviar a inscrição para o ERP")
                        
                    })
            }else{
                window.alert('Não será possível enviar a Parcela, pois o repasse ainda não foi realizado.')
            }
        
        
        },
        enviarContratoErp(){
            this.erro = null;
            $('#sincronizarEnvioInscricao').modal('show');
            let url='/api/v1/Erp/Inscricoes/'+this.unidade.id+'/incluircontratomatricula';
            
            let formData = new FormData();
            console.log('contrato',this.inscricaoAluno)
            formData.append('contrato', JSON.stringify(this.inscricaoAluno))
            formData.append('webhook', JSON.stringify(this.webHook))
            
            
            let configuracao = {
                // method:'post',
                // headers:{
                //     // // 'Accept': 'application/json',
                //     // // 'Authorization': this.$root.token(),
                // }
            }
            
            axios.post(url,formData,configuracao)
                .then(response => {
                    
                    if(response.data.web_hook){
                        
                        this.requestWebhook = response.data.web_hook;

                    }
                    
                    if(response.data.erro && response.data.erro == true){
                        this.erro = response.data;
                    }
                    console.log(response.data)
                    $('#sincronizarEnvioInscricao').modal('hide');
                })
                .catch(errors => {
                    console.log(errors.response)
                    $('#sincronizarEnvioInscricao').modal('hide');
                    window.alert("Houve um erro ao enviar a inscrição para o ERP")
                    
                })
        },
        enviarNumeroMatriculaCrm(){
            window.alert("Teste");
        },
        dispararEventoValorMatricula(){
            this.erro = null;
            $('#EnviarValorMatricula').modal('show');
            let url = '/api/v1/Crm/dispararEventoValorMatricula/'+this.unidade.id+'/webhook/'+this.webHook.id
            console.log('url',url)
            console.log('URL: ' + url)
            var config = {
                method: 'get',
                url: url,
                // headers: {
                //         'Accept': 'application/json',
                //         'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    console.log('EnviarValorMatricula',response.data)

                    if(response.data.erro==false){
                        this.requestWebhook = response.data.web_hook
                    }else{
                        console.log(response)
                        window.alert(response.data.mensagem);
                    }
                    
                    $('#EnviarValorMatricula').modal('hide');
                })
                .catch(function (error) {
                    console.log('error',error);
                    window.alert('Houve um erro ao enviar o valor da Matrícula para o CRM. Contate o Administrador do EduConnect CRM!')
                    
                    $('#EnviarValorMatricula').modal('hide');
                    //this.erro = error
                    console.log(error);
                });
                
        },
        documentosEntreguesAlunoPostados(){
            let docs_entregues = []
            if(this.inscricaoAluno.Pessoa.DocumentosEntregues.length>0){

                
                for(let i = 0; i < this.inscricaoAluno.Pessoa.DocumentosEntregues; i++){
                    
                    docs_entregues.push(
                        {
                            TipoDocumento: this.inscricaoAluno.Pessoa.DocumentosEntregues[i].TipoDocumento,
                            Validado: 1,
                            Anexo: this.inscricaoAluno.Pessoa.DocumentosEntregues[i].url,
                            NomeArquivo: this.inscricaoAluno.Pessoa.DocumentosEntregues[i].NomeArquivo,
                            IdAnexo: this.inscricaoAluno.Pessoa.DocumentosEntregues[i].IdAnexo,
                            upload_documento:this.inscricaoAluno.Pessoa.DocumentosEntregues[i].upload_documento,
                          }
                    )

                    // if(this.inscricaoAluno.Pessoa.DocumentosEntregues[i].TipoDocumento>0){

                    //     this.prospect.documentos_entregues[i].existe = true

                    // }else{

                    //     this.prospect.documentos_entregues[i].existe = false

                    // }

                }
            }
            this.inscricaoAluno.Pessoa.DocumentosEntregues = docs_entregues;
            console.log('docs_entregues',docs_entregues)
        },
        documentosEntreguesAluno(tipoDocumento){

            let docs_entregues = []
            if(this.prospect.documentos_entregues.length>0){

                
                for(let i = 0; i < this.prospect.documentos_entregues.length; i++){
                    
                    docs_entregues.push(
                        {
                            TipoDocumento: tipoDocumento,
                            Validado: 1,
                            Anexo: this.prospect.documentos_entregues[i].url,
                            NomeArquivo: this.prospect.documentos_entregues[i].nome,
                            IdAnexo: null,
                            upload_documento:this.prospect.documentos_entregues[i].upload_documento,
                            descricaodocumentocrm:this.prospect.documentos_entregues[i].descricaodocumentocrm
                          }
                    )

                    if(this.prospect.documentos_entregues[i].codigodocumento>0){

                        this.prospect.documentos_entregues[i].existe = true

                    }else{

                        this.prospect.documentos_entregues[i].existe = false

                    }

                }
            }
            this.inscricaoAluno.Pessoa.DocumentosEntregues = docs_entregues;
            console.log('docs_entregues',docs_entregues)
            
        },
        converteJsonObjeto(dados){
            //var x = JSON.stringify(dados.substring(1,dados.length-1),null,'\t');
            var a = JSON.parse(dados.substring(1,dados.length-1))
            //console.log(a)
            return a
        },
        getDateToDay(){
            var d = new Date()
            //console.log('Data Atual',d);
            return d
        },
        formatDate(date,idioma) {
            // console.log(date,idioma)
            var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + (d.getDate()),
            year = d.getFullYear();
            
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            if(idioma==1){
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }else if(idioma==2){
                let dt = [day, month, year].join('/');
                if(dt=='31/12/1969'){
                    return null
                }else{
                    return dt;
                }
            }else{
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }
        },
        daraHoraBrasileiro(date){
            let dataHora = new Date(date)
            // let dataHoraUtc = new Date()
            return dataHora.toLocaleString('pt-BR', { timezone: 'UTC' })
        },
        getEstiloStatus(status = null || status==''){
            if(status==null){
                return '';
            }else if(status=='success' || status==2){
                return 'alert alert-success text-center'
            }else if (status=='error' || status==3){
                return 'alert alert-danger text-center'
            }else if(status=='pending' || status==1){
                return 'alert alert-primary text-center'
            }else if(status=='warning' || status==4){
                return 'alert alert-warning  text-center'
            }else {
                return 'alert alert-light text-center'
            }
        },
        getEstiloStatusRequisicao(status = null || status==''){
            if(status==null){
                return '';
            }else if(status=='success' || status==2){
                return 'alert alert-success text-center'
            }else if (status=='error' || status==3){
                return 'alert alert-danger text-center'
            }else if(status=='pending' || status==1){
                return 'alert alert-primary text-center'
            }else if(status=='warning' || status==4){
                return 'alert alert-warning  text-center'
            }else {
                return 'alert alert-danger text-center'
            }
        },
        getEstyloDescricaoStatusRequisicao(status = null){
            if(status==null || status==''){
                return 'AGUARDANDO';
            }else if(status=='success' || status==2){
                return 'SUCESSO'
            }else if (status=='error' || status==3){
                return 'ERRO'
            }else if(status=='pending' || status==1){
                return 'PENDENTE'
            }else if(status=='warning' || status==4){
                return 'AVISO'
            }else {
                return ''
            }
        },
        getDescricaoStatusRequisicao(aluno_captado){
            var status = (aluno_captado.tipoeventoaviso=='c' && aluno_captado.status_inscricao!=null ?
                    aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_post_contrato!=null ? 
                        aluno_captado.status_post_contrato  : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_inscricao!=null ? 
                            aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='m' && aluno_captado.status_inscricao!=null ? 
                                aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='v' && aluno_captado.status_valormatricula!=null ? 
                                    aluno_captado.status_valormatricula : aluno_captado.status
                                )
                            )
                        )
                    )
                )

            
            if(status==null || status==''){
                return status;
            }else if(status=='success' || status==2){
                return 'SUCESSO'
            }else if (status=='error' || status==3){
                return 'ERRO'
            }else if(status=='pending' || status==1){
                return 'PENDENTE'
            }else if(status=='warning' || status==4){
                return 'AVISO'
            }else {
                return status
            }
        },
        
    },
    mounted(){
        this.ParcelamentoMatricula = this.objetoParcelamento
        this.AtualizacaoCadastralMatricula = this.objetoAtualizacaoCadastral
        // notas não lidas: leitura obrigatória assim que o carregamento inicial do CRM fechar
        $('#GetDadosInscrito').one('hidden.bs.modal', () => {
            if(this.$refs.notasWebhook){
                this.$refs.notasWebhook.exigirLeituraPendentes()
            }
        })
        this.getDadosInscricaoAluno();
    },
     created(){
        $('#GetDadosInscrito').modal('show');
        
        this.requestWebhook = this.webHook;
        
        //this.inscricaoAluno = this.objetoInscricao
        
    },
    
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.dc-tela {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

// ---------------------------------------------------------------------------
// Cabeçalho
// ---------------------------------------------------------------------------
.dc-cabecalho__topo {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
}

.dc-identidade {
    display: flex;
    align-items: center;
    gap: .9rem;
    min-width: 0;
}

.dc-identidade__avatar {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1.1rem;
    color: #fff;
    background: linear-gradient(135deg, $ec-petroleo 0%, $ec-turquesa 100%);
}

.dc-identidade__texto { min-width: 0; }

.dc-identidade__sobre {
    font-size: .75rem;
    color: $ec-texto-suave;
}

.dc-identidade__nome {
    margin: .1rem 0 .4rem;
    font-size: 1.3rem;
    overflow-wrap: anywhere;
}

.dc-identidade__selos {
    display: flex;
    flex-wrap: wrap;
    gap: .35rem;
}

.dc-acoes {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;

    .dropdown-item.disabled { cursor: not-allowed; }
}

.dc-resumo {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: .75rem 1.25rem;
    margin: 1.1rem 0 0;
    padding: .9rem 1rem;
    background: $ec-fundo;
    border: 1px solid $ec-borda;
    border-radius: $border-radius-lg;

    &--contrato { margin: .75rem 0 1rem; }
}

.dc-resumo__item {
    min-width: 0;

    &--largo { grid-column: span 2; }

    dt {
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: $ec-texto-suave;
        margin-bottom: .1rem;
    }

    dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
    }
}

.dc-opcao-documentos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: .25rem 1rem;
    margin-top: .9rem;
}

.dc-alerta-notas {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: .5rem 1rem;
    margin: .9rem 0 0;
}

.dc-avisos {
    margin-top: .9rem;

    &:empty { display: none; }

    .alert {
        margin-bottom: .5rem;
        font-weight: 600;

        &:last-child { margin-bottom: 0; }
    }
}

// ---------------------------------------------------------------------------
// Blocos com abas
// ---------------------------------------------------------------------------
.dc-bloco .tab-pane { padding-top: .75rem; }

.dc-quebra { overflow-wrap: anywhere; }

.ec-tabela td { vertical-align: middle; }

// mensagens de log costumam ser longas: deixa a coluna mais larga que o padrão
.ec-tabela td.dc-col-mensagem { max-width: 36rem; min-width: 14rem; }

.dc-select-tipo { min-width: 14rem; }

// botão de ação desabilitado dentro do <span> do tooltip
.dc-acao-indisponivel {
    pointer-events: none;
    opacity: .45;
}

// webhook aberto nesta tela, destacado no histórico
.ec-tabela tbody tr.dc-linha-atual:nth-of-type(n) > td { background: rgba($ec-turquesa, .08); }

// Parcelamento: as linhas de eventos intercalam as faturas, então sem zebra
.dc-parcelas tbody tr:nth-of-type(even):not(:hover) > td { background-color: transparent; }

.ec-tabela tbody tr.dc-subtabela:nth-of-type(n) > td {
    background: $ec-fundo;
    padding: .4rem .75rem .75rem 2rem;
    white-space: normal;
    font-weight: 400;

    th {
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: $ec-texto-suave;
        border-top: 0;
        white-space: nowrap;
    }

    td { background: transparent; }
}

.dc-subtabela__titulo {
    display: block;
    margin-bottom: .2rem;
    font-size: .72rem;
    font-weight: 600;
    color: $ec-texto-suave;
}

.dc-subtitulo {
    margin: 0 0 .5rem;
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
    color: $ec-texto-suave;
}

.dc-dica,
.dc-rodape-tabela {
    font-size: .8rem;
    color: $ec-texto-suave;
    margin: .25rem 0 .75rem;
}

.dc-rodape-tabela { margin: .75rem 0 0; color: $red; }

// estado vazio/carregando dos documentos (mesmo visual de .ec-tabela__estado)
.dc-vazio {
    padding: 2.5rem 1rem;
    text-align: center;
    color: $ec-texto-suave;

    p { margin: .6rem 0 0; font-size: .9rem; }
}

@media (max-width: 767.98px) { // = media-breakpoint-down(sm)
    // celular: o cartão de eventos ocupa a largura toda, sem recuo
    .ec-tabela tbody tr.dc-subtabela:nth-of-type(n) > td { padding: .5rem .75rem; font-size: .8rem !important; }

    // webhook atual não tem ação: some com o rodapé vazio do cartão
    .ec-tabela tbody tr.dc-linha-atual > td.ec-tabela__col-acoes { display: none; }

    .ec-tabela td.dc-col-mensagem { min-width: 0; }
    .dc-select-tipo { min-width: 0; }
}

// ---------------------------------------------------------------------------
// Carregando
// ---------------------------------------------------------------------------
.dc-esqueleto {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
}

.dc-esqueleto__linha {
    height: 38px;
    border-radius: $border-radius;
    background: linear-gradient(90deg, #eef3f5 0%, #f7fafb 50%, #eef3f5 100%);
    background-size: 200% 100%;
    animation: dc-brilho 1.4s ease-in-out infinite;
}

@keyframes dc-brilho {
    from { background-position: 100% 0; }
    to { background-position: -100% 0; }
}

@media (max-width: 575.98px) {
    .dc-acoes { width: 100%; }
    .dc-acoes > .btn, .dc-acoes > .btn-group { flex: 1 1 100%; }
    .dc-resumo__item--largo { grid-column: 1 / -1; }
}
</style>
